<template>
  <div :class="b()">
    <slot />
  </div>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'checkbox-group',

  props: {
    value: null,
    disabled: Boolean,
    max: {
      default: 0,
      type: Number
    }
  },

  watch: {
    value(val) {
      this.$emit('change', val);
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/checkbox-group/index.vue